import axios from 'axios';
import { Message } from 'element-ui';
import { getAppEnv,logout } from './tools';
import {message} from './message'

// import store from '@/store';
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 15000, // request timeout
});

// request 拦截器
instance.interceptors.request.use(
  async (config) => {
    // if (store.getters.token) {
    //   // eslint-disable-next-line no-param-reassign
    // }
    // FIXME: token 添加获取错误流程
    // TODO: token 错误 过期跳回u.qizuang.com/login
    // eslint-disable-next-line no-param-reassign
    const result = await getAppEnv()
    config.headers.token = localStorage.getItem('token');
    config.headers['App-Env'] = result || localStorage.getItem('App-Env')
    // eslint-disable-next-line no-param-reassign
    return config;
  },
  (error) => Promise.reject(error),
);

// response 拦截器
instance.interceptors.response.use(
  async (response) => {
    if ([3000004,40001,3000003,20003].includes(response.data.error_code)){
      message.error(response.data.error_msg);
      logout()
    }
    return response;
  },
  (error) => {
    Message({
      message: error,
      type: 'error',
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  },
);

export default instance;
